/**
 * Status states of a child view during its lifecycle of getting loaded, instantiated and rendered
 */ export var ChildViewStatus = /*#__PURE__*/ function(ChildViewStatus) {
    /** If the view is in error state and cannot be rendered, from failures in asset-loading or instantiation */ ChildViewStatus["Error"] = "Error";
    /** If the view's instatiator/render asset scripts have not been lazy-loaded yet */ ChildViewStatus["NotLoaded"] = "NotLoaded";
    /** The view's instatiator loading/instantiation process has begun */ ChildViewStatus["InstantiationStarted"] = "InstantiationStarted";
    /** The view's instatiator/render asset scripts have been lazy-loaded, instatiator can now be invoked */ ChildViewStatus["ScriptsLoaded"] = "ScriptsLoaded";
    /** The view's instatiator has been successfully called, it can now be rendered */ ChildViewStatus["Instantiated"] = "Instantiated";
    /** The view needs to be re-instantiated */ ChildViewStatus["ReInstantiate"] = "ReInstantiate";
    return ChildViewStatus;
}({});
/**
 * Child view types
 */ export var ChildView = /*#__PURE__*/ function(ChildView) {
    /** Premium plan view */ ChildView["PremiumPlan"] = "PremiumPlan";
    /** Portfolio view */ ChildView["Portfolio"] = "Portfolio";
    return ChildView;
}({});
